const KPIS = [
  { key: "total", label: "Clics totales", icon: "fa-mouse-pointer", hint: "Desde el inicio" },
  { key: "today", label: "Clics hoy", icon: "fa-sun", hint: "Hoy (UTC)" },
  { key: "whatsapp_total", label: "Clics a WhatsApp", icon: "fa-whatsapp", brand: true, hint: "Todos los botones verdes" },
  { key: "leads_total", label: "Leads registrados", icon: "fa-user-plus", hint: "Formularios enviados" },
];

export const StatsKpis = ({ data, leads }) => {
  const values = { ...data, leads_total: leads ? leads.total : 0 };
  return (
    <section className="stats-kpis" data-testid="stats-kpis">
      {KPIS.map(({ key, label, icon, brand, hint }, i) => (
        <article
          key={key}
          className={`stats-kpi ${key === "whatsapp_total" ? "stats-kpi-wa" : ""}`}
          style={{ animationDelay: `${i * 80}ms` }}
          data-testid={`stats-kpi-${key}`}
        >
          <div className="stats-kpi-icon"><i className={`${brand ? "fab" : "fas"} ${icon}`} /></div>
          <p className="stats-kpi-label">{label}</p>
          <p className="stats-kpi-value" data-testid={`stats-kpi-${key}-value`}>{values[key].toLocaleString("es-MX")}</p>
          <p className="stats-kpi-hint">{hint}</p>
        </article>
      ))}
    </section>
  );
};

export default StatsKpis;
